module.exports = __webpack_public_path__ + "media/img/header-compu-hero-5e0e8424.png";